import { useCallback, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {
  PATH_MISSION_ACCOUNTING_DEFAULT,
  PATH_MISSION_DEFAULT,
} from '../../app/constants/paths.constant';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { useBuildPaths } from '../../hooks/useBuildPaths.hook';
import { useMissionReadyContext } from '../../contexts/MissionContext/hooks/useMissionReadyContext.hook';
import { useAccountingReadyContext } from '../../contexts/AccountingContext/hooks/useAccountingReadyContext.hook';
import { MissionAccountingInfoStateForm } from '../../forms/MissionAccountingInfoState';
import { useMissionBreadcrumbPaths } from '../../hooks/useMissionBreadcrumbPaths.hook';
import { useMissionSpaceWording } from '../../hooks/useMissionSpaceWording.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { MissionAccountingComplianceDialog } from './MissionAccountingComplianceDialog';
import { PennylaneAccounting } from './PennylaneAccounting';
import { QuotationOptionsReminder } from './QuotationOptionsReminder';

export const MissionAccountingReady = () => {
  const { missionId, folderId, mission } = useMissionReadyContext();
  const missionWording = useMissionSpaceWording();
  const missionBreadcrumbPaths = useMissionBreadcrumbPaths();
  const { missionAccountingInfo } = useAccountingReadyContext();

  const [isInEditionMode, setIsInEditionMode] = useState(false);

  const enterEditionMode = useCallback(() => {
    setIsInEditionMode(true);
  }, []);

  const leaveEditionMode = useCallback(() => {
    setIsInEditionMode(false);
  }, []);

  const { paths: missionPaths } = useBuildPaths(
    {
      default: PATH_MISSION_DEFAULT,
      accounting: PATH_MISSION_ACCOUNTING_DEFAULT,
    },
    { folderId, missionId },
  );

  return (
    <>
      <MissionAccountingComplianceDialog />
      <Helmet>
        <title>
          {buildDocumentTitle(
            `Fiche Comptabilité ${missionWording.ofName}`,
            mission.code,
          )}
        </title>
      </Helmet>
      <Breadcrumbs
        paths={[
          ...missionBreadcrumbPaths,
          {
            to: missionPaths.accounting,
            label: 'comptabilité',
            key: 'accounting',
          },
        ]}
      />
      <PageTitle code={mission.code} title={mission.consolidation.title} />
      <Stack spacing={4}>
        <QuotationOptionsReminder />
        <MissionAccountingInfoStateForm
          enterEditionMode={enterEditionMode}
          isInEditionMode={isInEditionMode}
          leaveEditionMode={leaveEditionMode}
          missionAccountingInfo={missionAccountingInfo}
          missionId={missionId}
        />
        <Divider />
        <div>
          <Typography gutterBottom variant="h6">
            Données Pennylane
          </Typography>
          <PennylaneAccounting />
        </div>
      </Stack>
    </>
  );
};
